/* @flow */
import { Record, fromJS } from 'immutable';

// A Treatment is a specific configuration of a feature.
export type RawFlag = {
  treatment: String,
  config: String,
};

export const Flag = Record({
  treatment: 'control',
  config: null
});

export const flagsToOrderedMap = (flags: Object) => {
  return fromJS(flags)
    .toOrderedMap()
    .mapEntries(([k, v]) => [k, Flag(v)]);
};



// WEBPACK FOOTER //
// ./src/app/modules/features/types.js